module.exports = require('./head');



//////////////////
// WEBPACK FOOTER
// ../~/lodash/first.js
// module id = 1050
// module chunks = 0